import { ChangeDetectionStrategy, Component, inject, input, model } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  SearchResultItemComponent,
  SearchResultRenderer,
  SOFT_SHELL_SAVE_LAST_VIEWED,
  SOFT_SHELL_SEARCH_DISMISS,
} from '@softapps/core';
import { TranslatePipe } from '@softline/ui-core';
import { Ticket } from '../../data/ticket.model';
import { TicketQueryService } from '../../services/ticket-query.service';

@Component({
  selector: 'soft-ticket-search-result',
  imports: [SearchResultItemComponent, TranslatePipe],
  templateUrl: './ticket-search-result.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketSearchResult extends SearchResultRenderer<Ticket> {
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);
  readonly ticketQueryService = inject(TicketQueryService);
  readonly dismissSearchOverlay = inject(SOFT_SHELL_SEARCH_DISMISS);
  readonly saveLastViewed = inject(SOFT_SHELL_SAVE_LAST_VIEWED, { optional: true });

  override readonly result = input.required<Ticket>();
  override readonly highlighted = input(false);
  override readonly disabled = model(false);

  async openTicket(id: number): Promise<void> {
    if (!id) {
      return;
    }
    const ticket = this.result();
    this.saveLastViewed?.({
      key: String(id),
      number: String(id),
      title: ticket.name,
      url: `/ticket/${id}`,
    });
    await this.router.navigate(['/ticket', id], {
      queryParams: this.route.snapshot.queryParams,
    });
    await this.dismissSearchOverlay();
  }
}
